<li (click)="onCardClick()" class="company-card" [ngClass]="{ active }">
  <div class="company-info">
    <img [src]="company.logoUrl ? company.logoUrl : './assets/images/company-default.png'" alt="" />
    <div class="company-info__employee">
      <span class="company-info__employee-name">{{ company.employee | fullName }}</span>
      <div class="company-info__employee-status">
        <app-status-label *ngIf="company.employee.availability" [label]="company.employee.availability" [shouldCropLabel]="true"/>
        <span *ngIf="company.ownerUserAccountId === company.employee.userAccountId" class="company-info__employee-status__owner">
          {{ 'subscription.owner' | translate }}
        </span>
      </div>
    </div>
  </div>
  <span class="company-name">{{ company.name }}</span>
  <app-employee-titles *ngIf="company.employee.titles.length > 0" [titles]="company.employee.titles"></app-employee-titles>
  <div class="subscription" *ngIf="isOwner$ | async">
    <app-company-card-subscription [company]="company" />
  </div>
</li>
